
<div class="DropTarget">
  <div class="DropTarget_Content">
    <div class="DropTarget_Text">Drop here</div>
  </div>
</div>
